<template>
  <div class="col-xs-12 col-md-4 job-card">
    <div class="table-responsive">
      <p>Overview</p>
      <table class="datatable table mb-0">
        <tbody>
          <tr>
            <td>Job Profile</td>
            <td>
              <select
                name="job profile"
                id="job_profile"
                class="form-control"
                v-model="vacancy.jobProfileId"
              >
                <option
                  v-for="(item, index) in profiles"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.title }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td>Number of Occupancy</td>
            <td>
              <input
                class="form-control"
                type="number"
                v-model="vacancy.quantity"
              />
            </td>
          </tr>
          <tr>
            <td>Designation</td>
            <td>
              <multiselectvue
                class="from-control"
                v-model="designationDetails"
                placeholder="Select Designation"
                :custom-label="nameOfSalaryGroup"
                :options="sortedDesignations"
                :searchable="true"
                @select="optionSelectedSalaryGroup"
                :allow-empty="false"
              >
                <template
                  slot="singleLabel"
                  slot-scope="{ option }"
                  >{{ option.name }}
                </template>
              </multiselectvue>
              <!-- <select
                name="designation"
                id="designation"
                class="form-control"
                v-model="vacancy.designationId"
              >
                <option
                  v-for="(item, index) in designations"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select> -->
            </td>
          </tr>
          <tr>
            <td>Type</td>
            <td>
              <select v-model="vacancy.type" class="select form-control">
                <option>-- Select --</option>
                <option value="Fulltime">Fulltime</option>
                <option value="Parttime">Parttime</option>
                <option value="Youth Corp">Youth Corp</option>
                <option value="IT">IT</option>
                <option value="Intern">Intern</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>Summary</td>
            <td>
              <textarea
                style="height: auto !important"
                class="form-control"
                rows="10"
                type="text"
                v-model="vacancy.description"
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { jobService } from "@/services/jobService";
import { organizationService } from "@/services/organizationService";
import { authenticationService } from "@/services/authenticationService";
export default {
  props: {
    vacancy: {},
    currentOffice: {}
  },

  data() {
    return {
      //vacancy: this.vacancy,

      designations: [],
      profiles: [],
      designationDetails: this.vacancy.designation ? this.vacancy.designation.name : null
      //currentOffice: this.currentOffice
    };
  },

  computed: {
    sortedDesignations: function() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }

      return this.designations
        ? this.designations.sort(compare)
        : this.designations;
    }
  },
  mounted() {
    this.getDesignations(), this.getProfiles();
    this.$emit("update:vacancy", this.vacancy);

    console.log(this.vacancy);
  },
  methods: {
    nameOfSalaryGroup({ name }) {
      return `${name}`;
    },

    optionSelectedSalaryGroup(option, id) {
      console.log(option.id);
      this.vacancy.designationId = option.id;
    },

    getDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;
        },
        error => {
          error = error;
        }
      );
    },
    getProfiles() {
      jobService.getJobProfiles(this.currentOffice.id).then(p => {
        this.profiles = p.filter(c => c.status == 1);
      });
    }
  },
  name: "vacancy-overview-card"
};
</script>



// WEBPACK FOOTER //
// src/components/vacancies/overview-card.vue